@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Tax.Com Documents Service Log Details"
                  cancelHelpContentId="app.cancel"
                  cancelClass="btn-primary"
                  [hideSave]="true"
                  (cancel)="cancel()">
    @if (taxDotComDocsSvcDiagnosticsDetail) {
        <div class="ws-flex-container-vertical ws-stretch">
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label>Request Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="taxDotComDocsSvcDiagnosticsDetail.requestPayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Response Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="taxDotComDocsSvcDiagnosticsDetail.responsePayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Logs:</label>
                <taxdotcom-docs-svc-log-details-grid
                    [detailLogs]="taxDotComDocsSvcDiagnosticsDetail.detailLogs">
                </taxdotcom-docs-svc-log-details-grid>
            </div>
        </div>
    }
</ws-modal-wrapper>
